import { render, staticRenderFns } from "./Page-Backers.vue?vue&type=template&id=438119a2&"
import script from "./Page-Backers.vue?vue&type=script&lang=js&"
export * from "./Page-Backers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports